import http from '../http';
import { coreURLConstruct, errorPayload, formatArrayQueries, successPayload } from '../formatter';

const dataParamsContruct = (data) => ({
  isReadAfterWrite: data.isReadAfterWrite || false,
  search: data.searchParameter,
});

const getTableData = async (filters) => {
  const baseURL = coreURLConstruct(filters);
  const queries = formatArrayQueries(filters);

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/markets/grid?${queries}`,
      params: dataParamsContruct(filters),
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getListData = async (filters) => {
  const baseURL = coreURLConstruct();
  const queries = formatArrayQueries(filters);

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/markets?${queries}`,
      params: dataParamsContruct(filters),
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getSingleMarket = async (id, params) => {
  const baseURL = coreURLConstruct();
  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/markets/${id}`,
      params,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const updateMarket = async (id, data) => {
  const baseURL = coreURLConstruct();
  try {
    const response = await http({
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
      url: `${baseURL}/markets/${id}`,
      data,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const addMarket = async (data) => {
  const baseURL = coreURLConstruct();
  try {
    const response = await http({
      method: 'POST',
      url: `${baseURL}/markets`,
      data,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const deleteMarket = async (id) => {
  const baseURL = coreURLConstruct();
  try {
    const response = await http({
      method: 'DELETE',
      url: `${baseURL}/markets/${id}`,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getMarketTranslations = async (id, filters) => {
  const baseURL = coreURLConstruct();
  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/markets/${id}/translations`,
      params: {
        isReadAfterWrite: filters?.isReadAfterWrite || false,
      },
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getMarketsSpecifierTypes = async () => {
  const baseURL = coreURLConstruct();
  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/markets/specifiers/types`,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getMarketsFilters = async (filters) => {
  const baseURL = coreURLConstruct();
  const queries = formatArrayQueries(filters);
  const queryString = queries ? `?${queries}` : '';
  const params = dataParamsContruct(filters);

  try {
    const response = await http({
      url: `${baseURL}/markets/filters${queryString}`,
      method: 'get',
      params,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

export {
  getTableData,
  getListData,
  getSingleMarket,
  updateMarket,
  addMarket,
  deleteMarket,
  getMarketTranslations,
  getMarketsSpecifierTypes,
  getMarketsFilters,
};
